import React from 'react'

import Grid from './Grid'
import SearchFormContainer from './SearchFormContainer'

const SearchForm = () => {
  return (
    <Grid>
      <SearchFormContainer />
    </Grid>
  )
}

export default SearchForm
